





















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { CertificateLocale } from '@front-app/api-generated/learning-management-api';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';

const LANGUAGE_OPTIONS: CertificateLocale[] = [
	CertificateLocale.EnCa,
	CertificateLocale.FrCa,
];

// Each language choice should display in the actual language to make it easier for
// users to switch
const LANGUAGE_LABELS = {
	[CertificateLocale.EnCa]: 'English',
	[CertificateLocale.FrCa]: 'Français',
};

export default defineComponent({
	components: { SelectBox, FormLabel, FormSection },
	props: {
		value: {
			type: String as PropType<CertificateLocale>,
			required: true,
		},
	},
	setup() {
		const getLabelForKey = (key: CertificateLocale): string => LANGUAGE_LABELS[key];
		const selectOptions = computed(() => LANGUAGE_OPTIONS.map((key) => ({
			key,
			label: getLabelForKey(key),
		})));
		return {
			getLabelForKey,
			selectOptions,
		};
	},
});
